import { SettingLandingContactInformationContainer } from "../";

export const SettingLandingContactMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingContactInformationContainer />
    </div>
  );
};
